var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"last-launcher"},[_c('div',{staticClass:"last-date"},[_vm._v(_vm._s(_vm._column.lastInfo.lastDate.format_login_time()))]),_c('div',{staticClass:"last-user"},[_vm._v(_vm._s(_vm._column.lastInfo.lastUser))])])
}
var staticRenderFns = []

export { render, staticRenderFns }